import {Injectable} from '@angular/core';
import {PreloadingStrategy, Route} from '@angular/router';
import {EMPTY, Observable, defer, shareReplay, switchMap} from 'rxjs';

const SETTLE_MS = 2000;

/**
 * Preload every lazy route except those marked `data.preload: false`.
 * The router asks only after the first navigation ends. The wait then gives
 * the map about two seconds before other screens start downloading.
 */
@Injectable({providedIn: 'root'})
export class SettledPreloadingStrategy implements PreloadingStrategy {
  private readonly settled$ = defer(() => waitForSettle()).pipe(
    shareReplay({bufferSize: 1, refCount: false}),
  );

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] === false) {
      return EMPTY;
    }
    return this.settled$.pipe(switchMap(() => load()));
  }
}

function waitForSettle(): Observable<void> {
  return new Observable((subscriber) => {
    const timeoutId = setTimeout(() => {
      subscriber.next();
      subscriber.complete();
    }, SETTLE_MS);
    return () => clearTimeout(timeoutId);
  });
}
